export enum ClientEnvKey {
    BooxiKey = 'booxiKey',
    WoosmapApiBaseUrl = 'woosmapApiBaseUrl',
    WoosmapKey = 'woosmapKey',
    ClientApiKey = 'clientApiKey',
    BuildEnvironment = 'buildEnvironment',
    RuntimeEnvironment = 'runtimeEnvironment',
    EkooWebsiteId = 'ekooWebsiteId',
}

export type ClientEnvKeysRecord = { [key in ClientEnvKey]: string };
